/**
 * Resolve the name shown in the splash greeting.
 *
 * Prefers the brass profile display name — the user-editable name set in the Profile
 * panel, and the one value present even under the local dev-auth bypass, where the auth
 * `name` claim is null. Falls back to the auth name, then the email, then a generic label.
 *
 * @param {{ displayName?: string|null }|null|undefined} profile brass profile (GET /brass/api/users/me/profile)
 * @param {{ name?: string|null, email?: string|null }|null|undefined} userInfo /auth/me identity
 * @returns {string}
 */
export function resolveGreetingName(profile, userInfo) {
  return profile?.displayName?.trim() || userInfo?.name?.trim() || userInfo?.email || 'Player';
}
